import React, { useState } from "react";
import axios from "axios";
import {
  TextField,
  Button,
  Box,
  Typography,
  Container,
  Alert,
  Avatar,
  Grid,
  Link,
} from "@mui/material";
import toast from "react-hot-toast";
import useSharedLink from "../SharedLink";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import LoadingButton from "@mui/lab/LoadingButton";
import ErrorRoundedIcon from "@mui/icons-material/ErrorRounded";
import axiosInstance from "../api/axiosInstance";

const VerifySecurityQuestions = ({ onNext }) => {
  const [email, setEmail] = useState("");
  const [answer1, setAnswer1] = useState("");
  const [answer2, setAnswer2] = useState("");
  const [alert, setAlert] = useState(false);
  const [alertContent, setAlertContent] = useState("");
  const sharedLink = useSharedLink();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axiosInstance.post(
        `${sharedLink}/api/verifySecurityQuestions`,
        {
          email,
          answer1,
          answer2,
        }
      );
      const { success, message } = res.data;
      if (success) {
        toast.success(message);
        onNext(email);
      } else {
        toast.error(message);
        setAlert(true);
        setAlertContent(message);
      }
    } catch (error) {
      console.error(error);
      const message = error.response
        ? error.response.data.message
        : "An error occurred while verifying security questions.";
      toast.error(message);
      setAlert(true);
      setAlertContent(message);
    }
  };
  
  
  return (
    <Container
      sx={{
        height: "80vh",
        width: { xs: "12", md: "12", xl: "12" }, // Adjusted for a more centered look
        backgroundColor: "rgba(255, 255, 255, 0.3)", // Semi-transparent white
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backdropFilter: "blur(10px)", // Glass effect
        borderRadius: "10px", // Optional: adds rounded corners
        border: "1px solid rgba(255, 255, 255, 0.18)", // Optional: adds a subtle border
        position: "absolute", // Ensures it stays in the center
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)", // Adjusts the positioning to truly center the div
        boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)", // Optional: adds a subtle shadow for depth
        overflow: "hidden", // Ensures no overflow outside the container
      }}
    >
      {alert && (
        <Alert severity="error" onClose={() => setAlert(false)}>
          {alertContent}
        </Alert>
      )}
      <Box>
        <Typography
          className="login-message"
          variant="h3"
          gutterBottom
          sx={{ ml: 10 }}
        >
          Forgot
        </Typography>

        <Typography
          className="login-message"
          variant="h3"
          gutterBottom
          sx={{
            ml: 10,
            fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
          }}
        >
          Your Password?
        </Typography>
      </Box>

      <Box
        className="login-container"
        component="form"
        onSubmit={handleSubmit}
        sx={{
          mt: 4,
          p: 4,
          boxShadow: 3,
          borderRadius: 2,
          bgcolor: "background.paper",
          marginLeft: "auto",
          marginRight: "20px",
          width: "400px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
          <ErrorRoundedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Verify Security Questions
        </Typography>
        <TextField
          fullWidth
          margin="normal"
          label="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <TextField
          fullWidth
          margin="normal"
          label="Your first college name?"
          value={answer1}
          onChange={(e) => setAnswer1(e.target.value)}
          required
        />
        <TextField
          fullWidth
          margin="normal"
          label="Your Favourite sport?"
          value={answer2}
          onChange={(e) => setAnswer2(e.target.value)}
          required
        />
        <LoadingButton
          variant="contained"
          color="primary"
          fullWidth
          type="submit"
          sx={{
            mt: 3,
            mb: 2,
            backgroundColor: "#e9a132",
            "&:hover": { backgroundColor: "#d8902e" },
          }}
          loading={false} // Assuming loading state is not implemented for this form
        >
          Verify
        </LoadingButton>
        <Grid container justifyContent="flex-end">
          <Grid item>
            <Link href="/login" variant="body2">
              Sign in?
            </Link>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export default VerifySecurityQuestions;
